import { IntegrationPartners, MetricTypes, DataSources, } from '@strength/db-schema';
import { z } from 'zod';
export const zMetricType = z.enum(MetricTypes);
export const zExerciseMetric = z.object({
    sortOrder: z.number(),
    metricId: z.uuid(),
    metricName: z.string(),
    metricType: zMetricType,
});
export const zDate = z.string().date();
export const zDateRange = z
    .object({ start: zDate, end: zDate })
    .refine((range) => range.start <= range.end, {
    message: 'invalidDateRange',
    path: ['end'],
});
export const zDataSource = z.enum(DataSources);
// Provenance of a set metric value: the profileId that entered it, or 'AMS'
// for values ingested from the cricket feed.
export const zSetMetricEnteredBy = z.union([z.uuid(), z.literal('AMS')]);
export const zSetMetric = z.object({
    metricId: z.uuid(),
    forCollection: z.boolean(),
    input: z.string().max(50),
    dataSource: zDataSource.optional(),
    enteredBy: zSetMetricEnteredBy.optional(),
    // ISO timestamp of when the value was ingested/entered.
    enteredOn: z.iso.datetime({ offset: true }).optional(),
});
export const zSet = z.object({
    sortOrder: z.number(),
});
export const zExercise = z.object({
    sortOrder: z.number(),
    libraryExerciseId: z.uuid(),
    exerciseName: z.string(),
    scheme: z
        .object({
        id: z.uuid(),
        name: z.string(),
    })
        .nullable(),
    instruction: z.string().nullable(),
    isEachSide: z.boolean().nullable(),
});
export const zWeightUnit = z.enum(['lbs', 'kg', 'oz', 'g']);
export const zTagType = z.enum([
    'exercise',
    'workout_template',
    'metric_category',
]);
export const zTag = z.object({
    id: z.uuid(),
    name: z.string(),
    type: zTagType,
});
export const zTagSelection = z.object({
    id: z.uuid(),
    sortOrder: z.number(),
    tag: zTag,
});
export const zPhaseType = z.enum([
    'preparation',
    'pre-season',
    'in-season',
    'post-season',
    'transition',
    'off-season',
]);
export const zIntegrationPartner = z.enum(IntegrationPartners);
export const zIntegrationPropertyValue = z.union([
    z.string().min(1),
    z.number(),
    z.boolean(),
]);
// z.partialRecord (not z.record): in zod v4, z.record with an enum key became
// exhaustive (every key required), but IntegrationProperties is a partial
// record — the DB default is `{}` and exercises rarely have all partners.
export const zIntegrationProperties = z.partialRecord(zIntegrationPartner, z.record(z.string(), zIntegrationPropertyValue));
export const zCompletionStatus = z.enum(['planned', 'completed', 'skipped']);
// Print options
export const zPrintWorkoutLayout = z.enum([
    'session',
    'cycle',
    'workout',
    'exercise',
    'uniform-session',
]);
export const zPrintOrientation = z.enum([
    'portrait',
    'landscape',
]);
export const zPrintView = z.enum([
    'expanded',
    'condensed',
]);
export const zPrintInstructions = z.enum([
    'inline',
    'separate',
    'none',
]);
export const zPrintLettering = z.enum([
    'all',
    'supersets',
    'none',
]);
export const zPrintHeaderSize = z.enum([
    'normal',
    'large',
]);
export const zPrintEachSidePlacement = z.enum([
    'exercise',
    'set',
]);
// Metric config
export const zMetricNumericType = z.enum([
    'decimal',
    'integer',
    'none',
]);
export const zTrainingTypeSchema = z.object({
    id: z.uuid(),
    name: z.string(),
});
//# sourceMappingURL=core.js.map